import { useContext } from "react"
import type { CanadaPriceBreakdownPricingFormInputProps } from "src/components"
import { CanadaPriceBreakdownPricingForm } from "src/components"
import { ErrorHandlerContext } from "src/context/errorHandler/ErrorHandlerContext"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { usePriceBreakdown } from "./usePriceBreakdown"

export const CanadaPriceBreakdownPricingFormContainer = withErrorHandler(
	({ fields, inventoryId, priceHistory }: CanadaPriceBreakdownPricingFormInputProps) => {
		const priceBreakdown = usePriceBreakdown(inventoryId)
		const errorContext = useContext(ErrorHandlerContext)
		return (
			<CanadaPriceBreakdownPricingForm
				fields={fields}
				priceHistory={priceHistory}
				priceBreakdown={priceBreakdown}
				error={errorContext?.error?.message}
			/>
		)
	},
)
